module.exports = __webpack_public_path__ + "img/zhuanpan.81cee9c6.png";